// ==========================
//   FIXED PDP SALE TIMER
// ==========================

(function () {

  const targetDate = "2025-12-02";               
  const targetTime = "12:00:00";                 
  const pstOffset = "-08:00"; // PST fixed offset

  function elementsReady() {
    return (
      document.getElementById("days") &&
      document.getElementById("hours") &&
      document.getElementById("minutes") &&
      document.getElementById("seconds")
    );
  }

  // TRUE PST TARGET TIME
  function getTargetTime() {
    return new Date(`${targetDate}T${targetTime}${pstOffset}`).getTime();
  }

  const endTime = getTargetTime();

  function updateCountdown() {
    if (!elementsReady()) return;

    const now = Date.now();
    const distance = endTime - now;

    if (distance <= 0) {
      clearInterval(window.saleTimerInterval);
      const wrapper = document.querySelector(".countdown");
      if (wrapper) wrapper.style.display = "none";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById("days").innerText = days;
    document.getElementById("hours").innerText = hours;
    document.getElementById("minutes").innerText = minutes;
    document.getElementById("seconds").innerText = seconds;
  }

  function startTimerWhenReady() {
    if (!elementsReady()) {
      setTimeout(startTimerWhenReady, 300);
      return;
    }

    updateCountdown();
    window.saleTimerInterval = setInterval(updateCountdown, 1000);
  }

  document.addEventListener("DOMContentLoaded", startTimerWhenReady);

})();
